import { Component } from '@angular/core';
import { PageHeaderComponent } from '../../../page-header/component/page-header.component';
import { SectionBlogComponent } from '../../../section-blog/component/section-blog.component';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss'],
    standalone: true,
    imports: [PageHeaderComponent, SectionBlogComponent]
})
export class BlogComponent {
  heading = '1artifactware News & Articles';
  description = [];
  breadcrumbs = [{
    link: '/home',
    ariaLabel: 'Go back to home page',
    label: 'Home'
  }, {
    link: '',
    ariaLabel: '',
    label: 'Blog'
  }];
}
